(function () {
  "use strict";

  HomeCourseSidebarCtrl.$inject = ['$scope', '$rootScope', '$location', 'homeResource', 'trackingService', 'trainerPrivilege', '$window', 'courseTraineesResource', '$timeout', 'modalHelper'];
  angular
    .module('trainerWebApp.controllers')
    .controller('HomeCourseSidebarCtrl', HomeCourseSidebarCtrl);

  function HomeCourseSidebarCtrl($scope, $rootScope, $location, homeResource, trackingService, trainerPrivilege, $window,
                                 courseTraineesResource, $timeout, modalHelper) {

    $scope.serverCallInProgress = false;
    $scope.courseViewState = {
      traineeState: {
        invited: 0,
        invitedRemind: 0,
        missedCompletionDeadline: 0,
        missedCompletionDeadlineReset: 0,
        inProgress: 0,
        inProgressRemind: 0,
        failed: 0,
        failedReset: 0,
        passed: 0,
        passedReset: 0,
        numOfTrainees: 0
      },
      contentInfo: {},
      slideInfo: {},
      courseInSeries: [],
      courseSlidesPreview: [],
      permissions: {
        canCopyCourses: true,
        canDeleteCourses: true
      },
      hasConversions: false
    };

    var userRole = trainerPrivilege.roles();
    var canPreviewCourse = userRole.canPreviewCourse;
    $scope.canRemindTrainees = userRole.canRemindTrainees;
    $scope.canResetTrainees = userRole.canResetTrainees;

    var pollingTimeout;

    $scope.$watch('homeState.selectedItem', function () {
      stopPolling();
      if ($scope.homeState.selectedItem.type === "online" || $scope.homeState.selectedItem.type === "live") {
        setup($scope.homeState.selectedItem.id);
      }
    });

    function reloadCourseDetails(courseId, cb) {
      homeResource.getCourseDetail(courseId, function (result) {
        $scope.courseViewState.traineeState = result.traineeState;
        $scope.courseViewState.contentInfo = result.contentInfo;
        $scope.courseViewState.slideInfo = result.slideInfo;
        $scope.courseViewState.courseInSeries = result.courseInSeries;
        $scope.courseViewState.contentInfo.survey = result.contentInfo.survey > 0 ? 'Yes' : 'No';
        $scope.courseViewState.hasConversions = result.conversions.count > 0;

        if ($scope.courseViewState.hasConversions) {
          startPolling();
        } else {
          stopPolling();
        }

        if (cb) {
          cb();
        }
      });
    }

    function startPolling() {
      stopPolling();
      pollingTimeout = $timeout(function () {
        reloadCourseDetails($scope.homeState.selectedItem.id);
      }, 30000);
    }

    function stopPolling() {
      if (pollingTimeout) {
        $timeout.cancel(pollingTimeout);
        pollingTimeout = null;
      }
    }

    function setup(courseId) {
      reloadCourseDetails(courseId);
      $scope.carouselSrc = "pages/home/emptyCarousel.html";
      homeResource.getCoursePreviewItems(courseId, function (res) {
        if (!validateGetCourseSlidePreviewResult(res)) {
          return;
        }
        $scope.courseViewState.courseSlidesPreview = res.previewItems;
        $scope.carouselSrc = "pages/home/carousel.html";
      });

      $scope.courseViewState.permissions.canCopyCourses = userRole.canEditCourses;
      $scope.courseViewState.permissions.canDeleteCourses = userRole.canEditCourses;
      $scope.courseViewState.previewUrl = $scope.viewAsTraineeUrl + "#/preview/" + courseId;
    }

    $scope.carouselOptions = {
      auto: 0,
      wrap: null,
      vertical: false,
      scroll: 1,
      visible: 2.5,
      buttonNextHTML: '<div><i class="icon-caret-right"></i></div>',
      buttonPrevHTML: '<div><i class="icon-caret-left"></i></div>'
    };

    $scope.carouselSrc = "";

    $scope.courseStatus = {
      draft: {
        name: 'Draft',
        canDeleteCourse: true,
        canCopyCourse: true,
        canPreviewCourse: canPreviewCourse,
        canOpenCourse: true,
        viewNotStarted: true,
        viewInProgress: false,
        viewMissedDeadline: false,
        viewFailed: false,
        viewPassed: false
      },
      active: {
        name: 'Active',
        canDeleteCourse: false,
        canCopyCourse: true,
        canPreviewCourse: canPreviewCourse,
        canOpenCourse: true,
        viewNotStarted: true,
        viewInProgress: $scope.homeState.selectedItem.type != 'live',
        viewMissedDeadline: $scope.homeState.selectedItem.type != 'live',
        viewFailed: true,
        viewPassed: true
      },
      archive: {
        name: 'Archived',
        canDeleteCourse: true,
        canCopyCourse: true,
        canPreviewCourse: false,
        canOpenCourse: true,
        viewNotStarted: true,
        viewInProgress: $scope.homeState.selectedItem.type != 'live',
        viewMissedDeadline: $scope.homeState.selectedItem.type != 'live',
        viewFailed: true,
        viewPassed: true
      }
    };

    $scope.copyCourse = function (params) {
      $rootScope.$broadcast('$showLoadingSpinner', true);
      var courseId = params.id;
      trackingService.trackEvent(trackingService.pages.trainerHome.name, trackingService.pages.trainerHome.actions.copyCourseAction);

      homeResource.copyCourse(courseId, function (res) {
        $rootScope.$broadcast('courseCopied', res.courseId);
        $rootScope.$broadcast('$showLoadingSpinner', false);
        return $location.path('/TMS/Course_Dashboard/' + res.courseId);
      });
    };

    $scope.deleteCourse = function (params) {
      if (!params.id) return;
      $rootScope.$broadcast('courseDeletionRequestedEvent', params);
    };

    $scope.$on('courseDeletionConfirmedEvent', function (event, courseId, cb) {
      trackingService.trackEvent(trackingService.pages.trainerHome.name, trackingService.pages.trainerHome.actions.deleteCourseAction);

      homeResource.deleteCourse(courseId, function () {
        $rootScope.$broadcast('courseDeleted', courseId);
        (cb || angular.noop)();
      }, function (err) {
        (cb || angular.noop)();
      });
    });

    $scope.traineeStateClick = function (state) {
      var stateMap = {
        "invited": trackingService.pages.trainerHome.actions.manageCourseInvitedStateAction,
        "progress": trackingService.pages.trainerHome.actions.manageCourseStartedStateAction,
        "missed": trackingService.pages.trainerHome.actions.manageCourseMissedDeadlineStateAction,
        "passed": trackingService.pages.trainerHome.actions.manageCoursePassedStateAction,
        "failed": trackingService.pages.trainerHome.actions.manageCourseFailedStateAction
      };

      var filter = state;
      var subFilter = 'all';
      if (filter === 'passed' || filter === 'failed') {
        subFilter = filter;
        filter = 'completed';
      }
      trackingService.trackEvent(trackingService.pages.trainerHome.name, stateMap[state]);
      $location.path('/TMS/Distribute_Course/' + $scope.homeState.selectedItem.id + '/trainees').search('f', filter).search('gf', subFilter);
    };

    $scope.manageTrainees = function () {
      trackingService.trackEvent(trackingService.pages.trainerHome.name, trackingService.pages.trainerHome.actions.manageCourseTraineesAction);
      $location.path('/TMS/Distribute_Course/' + $scope.homeState.selectedItem.id + '/trainees');
    };

    var sampleCourseIds = [mfConfig.sampleCourseId, mfConfig.YammerSampleCourseID];

    $scope.onPreviewClicked = function (id) {
      if (!$scope.homeState.selectedItem.ipadCompatible) {
        modalHelper.messageBox({
          title: 'Unable to Preview Course',
          message: "To preview this course, you must upgrade this course for the iPad from the course dashboard.",
          buttons: [{label: 'OK'}]
        });
        return;
      }

      $window.open($scope.courseViewState.previewUrl);
      if (!~sampleCourseIds.indexOf(id)) {
        return;
      }

      //TODO: Preview course needs db action log.

      trackingService.trackKissMetricsEvent("clicked on", {
        courseId: id,
        action: "clicked preview button on right rail"
      });
    };

    $scope.onOpenCourseClicked = function (id) {

      trackOpenSampleCourse(id);

      if ($scope.openCourse) {
        trackingService.trackEvent(trackingService.pages.trainerHome.name, trackingService.pages.trainerHome.actions.gotoCourseAction);
        $scope.openCourse(id);
      }
    };

    function trackOpenSampleCourse(courseId) {
      if (!~sampleCourseIds.indexOf(courseId)) {
        return;
      }

      trackingService.trackKissMetricsEvent("clicked on", {
        courseId: courseId,
        action: "clicked go to course button on right rail"
      });
    }

    function getCourseSlidePreview(courseId) {
      homeResource.getCoursePreviewItems(courseId, function (res) {
        if (!validateGetCourseSlidePreviewResult(res)) {
          return;
        }
        $scope.courseViewState.courseSlidesPreview = res.previewItems;
      });
    }

    function validateGetCourseSlidePreviewResult(res) {
      if (res && !res.isAuthenticated) {
        $window.location = '/';
        return false;
      }

      return true;
    }

    $scope.seriesClick = function (seriesId) {
      trackingService.trackEvent(trackingService.pages.trainerHome.name, trackingService.pages.trainerHome.actions.filterBySeriesAction);
      $scope.clearSearch();
      $scope.selectItemById(seriesId);
    };

    $scope.showTraineesAction = function (state) {
      if (!$scope.homeState.selectedItem || $scope.homeState.selectedItem.status != "active") {
        return false;
      }

      if (!$scope.courseViewState || !$scope.courseViewState.traineeState) {
        return false;
      }

      return $scope.courseViewState.traineeState[state] > 0;
    };

    $scope.canRemind = function (state) {
      if (!$scope.showTraineesAction(state))
        return false;

      var key = state + 'Remind';
      return $scope.courseViewState.traineeState[key] > 0;
    };

    $scope.remindTrainees = function (state) {
      if (state != 'invited' && state != 'inProgress') {
        return;
      }

      if (!$scope.canRemind(state)) {
        return;
      }

      var key = state + 'Remind';
      var count = $scope.courseViewState.traineeState[key];
      var totalCount = $scope.courseViewState.traineeState[state];

      trackingService.trackEvent(trackingService.pages.trainerHome.name, trackingService.pages.trainerHome.actions.pokeRemindCourseTrainees);

      $scope.$broadcast('traineesToRemindEvent', count, {
        state: state,
        totalCount: totalCount
      });
    };

    $scope.$on('remindTraineesConfirmEvent', function (event, data, cb) {
      var state = data.state;
      var courseId = $scope.homeState.selectedItem.id;
      courseTraineesResource.pokeRemindCourseTraineesByState(courseId, state, function () {
        reloadCourseDetails($scope.homeState.selectedItem.id, cb);
      }, cb);
    });

    $scope.resetTrainees = function (state) {
      if (state != 'missedCompletionDeadline'
        && state != 'failed'
        && state != 'passed') {
        return;
      }

      var resetState = state + "Reset";

      if (!$scope.showTraineesAction(resetState)) {
        return;
      }

      var count = $scope.courseViewState.traineeState[resetState];
      trackingService.trackEvent(trackingService.pages.trainerHome.name, trackingService.pages.trainerHome.actions.resetCourseTrainees);

      $scope.$broadcast('courseBulkResetRequested', count, {
        state: state
      });
    };

    $scope.$on("courseBulkResetConfirmed", function (event, data, cb) {
      var state = data.state;
      var courseId = $scope.homeState.selectedItem.id;
      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      courseTraineesResource.retakeCourseByState(courseId, state, dateString, function () {
        reloadCourseDetails($scope.homeState.selectedItem.id, cb);
      }, cb);
    });

    $scope.$on('$destroy', function () {
      stopPolling();
    });


  }

})();
